import { createSelector } from 'reselect';

export const isSideMenuOpen = createSelector(
  state => state.sideMenu,
  sideMenu => sideMenu.isSideMenuOpen
);
